<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-md-12">
        <form @submit.prevent="onSubmit" enctype="multipart/form-data">
          <h5 class="mt-2">{{ $t("pages.users.person") }}</h5>
          <hr />
          <div class="row">
            <div class="col">
              <label>{{ $t("pages.users.firstname") }}</label>
              <input type="text" v-model.trim="user.firstname" class="form-control"
                placeholder="Prénom de l'utilisateur" required />
            </div>

            <div class="col">
              <label>{{ $t("pages.users.lastname") }} </label>
              <input type="text" v-model.trim="user.lastname" class="form-control" placeholder="Nom de l'utilisateur"
                required />
            </div>
          </div>
          <h5 class="mt-4">{{ $t("pages.users.contact") }}</h5>
          <hr />
          <div class="row">
            <div class="col">
              <label>{{ $t("pages.users.mail") }} </label>
              <input type="email" v-model.trim="user.email" class="form-control"
                placeholder="adresse mail de l'utilisateur" required />
            </div>
            <div class="col">
              <label>{{ $t("pages.users.phone") }}</label>
              <input v-model.trim="user.phone" class="form-control" placeholder="numéro de téléphone" required />
            </div>
          </div>
          <div class="row mt-4 mb-4">
            <div class="col">
              <label for="adress">{{ $t("pages.users.adress") }}</label>
              <textarea id="adress" v-model="user.address" class="form-control" placeholder="Adresse physique"
                rows="2"></textarea>
            </div>
            <div class="col mt-3 text-left">
              <div class="custom-control custom-switch mt-4">
                <input type="checkbox" v-model="user.actif" @click="toggle" class="custom-control-input"
                  id="customSwitch1" />
                <label class="custom-control-label" documentMetadata="customSwitch1">{{ $t("pages.users.activeUser")
                }}</label>
              </div>
            </div>
          </div>
          <h5>{{ $t("pages.users.roles") }}</h5>
          <hr />
          <div class="row" v-if="gettingRoles">
            <loading :active.sync="gettingRoles" :can-cancel="false" loader="dots" color="rgb(20, 80, 144)" :width="100"
              :is-full-page="false">
            </loading>
          </div>
          <div class="row" v-else>
            <div class="col-4" v-for="(role, index) in roles" :key="index">
              <div class="form-check mt-2">
                <input class="form-check-input" v-model="role.isTrue" type="checkbox" :value="role.id"
                  :id="role.name" />
                <label class="form-check-label" :for="role.name">
                  {{ role.name }}
                </label>
              </div>
            </div>
          </div>
          <hr />
          <div class="mt-4 mb-3">
            <div class="row">
              <div class="col-md-12 text-left">
                <button v-if="!this.isLoading" type="submit" class="btn btn-primary mr-2" :disabled="initializing">
                  {{ $t("pages.users.save") }}
                </button>
                <button class="btn btn-primary mr-2" type="button" v-else disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  {{ $t("pages.users.saving") }}
                </button>
                <router-link :to="{ name: 'Users' }" class="btn btn-light">{{ $t("pages.users.cancel") }}</router-link>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Loading from "vue-loading-overlay";
import PageHeader from "@/components/page-header";
import { mapActions } from "vuex";
import userApi from "../../../api/userApi";
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Users",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loading,
  },
  data() {
    return {
      title: "pages.users.updateUser",
      user: {},
      isLoading: false,
      initializing: false,
      gettingRoles: false,
      roles: {},
      userRoles: {},
    };
  },

  methods: {
    ...mapActions(["updateUser", "getRoles"]),
    onSubmit() {
      if (this.$can("update", "users")) {
        this.isLoading = true;
        const all_roles = this.roles.map((role) => {
          if (role.isTrue) {
            return {
              id: role.id,
              name: role.name,
              slug: role.slug,
            };
          }
          return null;
        });

        const data = {
          user: this.user,
          roles: all_roles,
          userId: this.$route.params.id,
        };

        this.updateUser(data).then((updated) => {
          if (updated) {
            this.isLoading = false;
            this.$toasted.success(this.$t('pages.users.actions.updated'));
            this.$router.push({ name: "Users" });
          } else {
            this.isLoading = false;
            this.$toasted.error(this.$t('pages.unauthorized.error_0'));
          }
        });
      } else {
        this.$toasted.error(this.$t('pages.unauthorized.forbidden'));
      }
    },
    toggle: function () {
      this.user.actif = !this.user.actif;
    },
    handleFileUpload(event) {
      this.user.picture = event.target.files[0];
    },
  },
  created() {
    if (!this.$can("update", "users")) {
      this.$$router.push("/");
    } else {
      this.initializing = true;
      this.gettingRoles = true;
      this.getRoles(this.$route.params.id)
        .then((response) => {
          if (response.status == 200) {
            this.roles = response.data;
            this.gettingRoles = false;
          } else {
            this.gettingRoles = false;
          }
        })
        .catch(() => {
          this.gettingRoles = false;
        });
      userApi
        .show(this.$route.params.id)
        .then((response) => {
          this.initializing = false;
          //this.roles = response.data.roleRead;
          this.userRoles = response.data.roles;
          this.user = response.data.userRead;
          this.roles = this.roles.map((role) => {
            for (let i = 0; i < this.userRoles.length; i++) {
              if (this.userRoles[i].id == role.id) {
                return {
                  id: role.id,
                  slug: role.slug,
                  name: role.name,
                  isTrue: true,
                };
              }
            }
            return {
              id: role.id,
              slug: role.slug,
              name: role.name,
              isTrue: false,
            };
          });
        })
        .catch(() => {
          this.initializing = false;
          this.$toasted.error(this.$t('pages.unauthorized.server_error'));
        });
    }
  },
};
</script>


